import { render } from "./GammeMaintenance.vue?vue&type=template&id=27a2a920&ts=true"
import script from "./GammeMaintenance.vue?vue&type=script&lang=ts"
export * from "./GammeMaintenance.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__